import React from 'react';
import LogisticsBanner from '../components/logistics/LogisticsBanner';
import LogisticsContent from '../components/logistics/LogisticsContent';

const Logistics = () => {
  return (
    <React.Fragment>
      <LogisticsBanner />
      <LogisticsContent />
    </React.Fragment>
  );
};

export default Logistics;
